import { render, staticRenderFns } from "./ViewDrawer.vue?vue&type=template&id=397ca89e&scoped=true"
import script from "./ViewDrawer.vue?vue&type=script&lang=js"
export * from "./ViewDrawer.vue?vue&type=script&lang=js"
import style0 from "./ViewDrawer.vue?vue&type=style&index=0&id=397ca89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ca89e",
  null
  
)

export default component.exports